export default __webpack_public_path__ + "static/media/whyBrokerIcon3.8c1c971e.webp";